import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { PriorityPatchRequest } from '@primatoo-ms-organization';
import { ApiClientConfig } from '../api-client-config';
import { DataProtectionGovernanceService } from '../interface/data-protection-governance-service';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';
import { UpsertUserColumnRequest } from 'it/primatoo/openapi/api/org/schemas/common/UpsertUserColumnRequest';
import { QuestionDetails } from '@ms-organization-entities';
import { CreateResponse } from 'it/primatoo/openapi/api/common/schemas/CreateResponse';

@Injectable({
  providedIn: 'root'
})
export class QuestionService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/questions/';
  }

  public findAll(): Observable<QuestionDetails[]> {
    const url = this.endpoint;
    return this.httpClient.get<QuestionDetails[]>(url);
  }

  public create(requestBody: QuestionDetails): Observable<CreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<CreateResponse>(url, requestBody);
  }

  public update(id: number, requestBody: QuestionDetails): Observable<void> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<void>(url, requestBody);
  }

  public getEndPointV1(): string {
    return this.endpoint;
  }

  public setPriority(id: number, request: PriorityPatchRequest): Observable<void> {
    return of();
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns/`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public updateUserColumns(columnsConfigurationUpsertRequest: UpsertUserColumnRequest): Observable<void> {
    const url = this.endpoint + 'user-columns';
    return this.httpClient.post<void>(url, {
      config: columnsConfigurationUpsertRequest.columns
    });
  }

}
